import type { StudentAppSetting as StudentAppSettingData } from '@mathflat/domain/Student'
import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'
import { setGroupBy } from '@/utils/common'

import type { StudentColl } from '../index'
import type { StudentId } from './StudentAppSetting'
import { StudentAppSetting } from './StudentAppSetting'

export class StudentAppSettingColl {
  private studentColl: StudentColl
  private appSettingMap: ExtendedMap<StudentId, StudentAppSetting>

  constructor(coll: StudentColl, appSettings: StudentAppSettingData[]) {
    makeAutoObservable(this)

    this.studentColl = coll
    this.appSettingMap = ExtendedMap.fromArr(
      [...appSettings]
        .map(
          (val) =>
            new StudentAppSetting({
              ...val,
              name: coll.get(val.studentId)?.name || '',
            }),
        )
        .sort((studentA, studentB) => studentA.name.localeCompare(studentB.name)),
      'studentId',
    )
  }

  get byFlatGrade() {
    if (!this.appSettingMap) return
    return setGroupBy(this.appSettingMap, (val) => {
      const student = this.studentColl.get(val.studentId)
      if (student) return student.schoolGrade.flatGrade - 1
    })
  }

  get settings() {
    return this.appSettingMap.values()
  }

  get isEmpty() {
    return this.studentColl.isEmpty
  }
}
